import { Injectable } from '@angular/core';
import { WindowOpenTarget } from './window-open-target.enum';
import { WindowOpenProperties } from './window-open-properties.interface';
import { NewRelicBrowserApi, NewRelicGlobalConfig } from 'common/telemetry/new-relic';

export type WindowType = Window & {
  Audio: typeof Audio,
  Notification: typeof Notification,
  MessageChannel: typeof MessageChannel,
  newrelic?: NewRelicBrowserApi,
  NREUM?: NewRelicGlobalConfig
};

@Injectable()
export class WindowService {
  public Audio: typeof Audio;

  private readonly _window: WindowType;

  constructor() {
    this._window = <WindowType>window;
    this.Audio = this._window.Audio;
  }

  getWindow(): WindowType {
    return this._window;
  }

  open(url: string, target?: WindowOpenTarget | string, properties?: WindowOpenProperties): Window {
    let propertiesString;

    if (properties) {
      propertiesString = Object.keys(properties).map(prop => `${prop}=${properties[prop]}`).join(', ');
    }

    return this._window.open(url, target, propertiesString);
  }

  getComputedStyle(elt: Element, pseudoElt?: string | null): CSSStyleDeclaration {
    return this._window.getComputedStyle(elt, pseudoElt);
  }

  get innerHeight(): number {
    return this._window.innerHeight;
  }

  get innerWidth(): number {
    return this._window.innerWidth;
  }

  get location(): Location {
    return this._window.location;
  }

  addEventListener(type: string, listener: EventListenerOrEventListenerObject, options?: boolean | AddEventListenerOptions): void {
    return this._window.addEventListener(type, listener, options);
  }

  removeEventListener(type: string, listener: EventListenerOrEventListenerObject, options?: boolean | AddEventListenerOptions): void {
    return this._window.removeEventListener(type, listener, options);
  }
}
